import React, { useEffect, useState } from "react";
import { Grid, Heading, Stack } from "@chakra-ui/react";
import { AuthenticatedLayout } from "layouts";
//import { contentful } from "api/contentful/client";
//import { getTrainingContent } from "api/contentful/queries.gql";
import { getTrainingContent } from "api/webservice/content";
import Section from "./Section";

const Training: React.FC = () => {
  const [sectionContainers, setSectionContainers] = useState([]);

  useEffect(() => {
    let sectionresults;

    //contentful.query(getTrainingContent).then(result => {
    //  sectionresults = result.data.courseContainerCollection.items.map((item: any) => item.sectionsCollection.items);
    //  if (sectionContainers.length === 0) {
    //    setSectionContainers(sectionresults);
    //  }
    //});
    getTrainingContent().then(result => {
      //console.log(result);
      sectionresults = result.items;
      //console.log(sectionresults);
      if (sectionContainers.length === 0) {
        setSectionContainers(sectionresults);
      }
    });
  }, [sectionContainers]);

  // only 1 course container so far, and all the sections are stored in the first element of sectionContainers
  const sections = (sectionContainers.length > 0)
  ? // @ts-ignore
  sectionContainers[0].fields.sections.map(s => s.fields)
  : [];

  return (
    <AuthenticatedLayout>
      <Heading size="lg" mb={6}>
        Training
      </Heading>
      {sections.map((section: any, index: any): any => (
        <Section
          sectionTitle={section.title}
          sectionTag={section.sectionTag}
        sectionTrainingContent={section.trainingMaterialsContent}
        />
      ))}
    </AuthenticatedLayout>
  );
};

export default Training;
